import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<any, editTeamBody>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/teams/${body.categoryId}/${body.teamId}`,
      method: 'PUT',
      body: body.body,
    }),
  });

type editTeamBody = {
  tournamentId: number;
  categoryId: number;
  teamId: number;
  body: {
    players: { name: string; phone: string }[];
    payment_method: string;
    payment_status: number;
  };
};
